
            const data = {"name":"phone-rotate-portrait","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M9 1H3a2 2 0 00-2 2v13a2 2 0 002 2h1v-3H3V3h6v8h2V3a2 2 0 00-2-2m14 20v-6a2 2 0 00-2-2H8a2 2 0 00-2 2v6a2 2 0 002 2h13a2 2 0 002-2M9 21v-6h12v6H9m14-11h-1.5c0-3-1.81-5.73-4.58-6.91L16 5l-2-4a9 9 0 019 9z\"/>"}}
        
                module.exports = data
                